import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { App } from "./App";
import { ToastProvider } from "./components/ui/Toast";
import { PeriodProvider } from "./lib/period";

const root = document.getElementById("root");
if (!root) throw new Error("Root element not found");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <PeriodProvider>
        <ToastProvider>
          <App />
        </ToastProvider>
      </PeriodProvider>
    </BrowserRouter>
  </StrictMode>,
);
